import { useState, useCallback } from 'react';
import { usePromise, useUpdateMonitor } from '.';
import app from '~/app';

export function useQuery( service, query={}, opts={} ) {
  useUpdateMonitor( 'useQuery', { service, query, opts } );
  const [ state, setState ] = useState( {} );

  const loader = useCallback( () => {
    if ( opts.live ) {
      app.service( service ).watch().find( { query } ).subscribe(
        data => setState( { data } ),
        error => setState( { error } ),
      );
    } else {
      app.service( service ).find( { query } )
        .then( data => setState( { data } ) )
        .catch( error => setState( { error } ) );
    }
  }, [ service, query, opts.live, setState ] );

  const promise = usePromise( loader );

  return { ...promise, ...state };
}
